module.exports = __webpack_public_path__ + "img/be-midia.618d75c4.jpg";